export default __webpack_public_path__ + "static/media/drink_title.dc6e1c48.svg";